// New message notification sound (ported from the legacy GlobalChat: same file, volume 0.5).
// The file is bundled by webpack (asset/resource), so the URL is correct in any deployment.
// Autoplay may be blocked until the first user interaction, so playback errors are ignored.
import soundUrl from '@containers/chat/assets/delivered-message-sound.mp3'

const SOUND_URL: string = soundUrl

let audio: HTMLAudioElement | null = null
let enabled = true

const ensureAudio = (): HTMLAudioElement | null => {
    if (audio) {
        return audio
    }
    try {
        audio = new Audio(SOUND_URL)
        audio.volume = 0.5
        audio.load()
    } catch {
        audio = null
    }
    return audio
}

export const setChatSoundEnabled = (value: boolean): void => {
    enabled = value
}

export const isChatSoundEnabled = (): boolean => enabled

export const playChatSound = (): void => {
    if (!enabled) {
        return
    }
    const el = ensureAudio()
    if (!el) {
        return
    }
    try {
        el.currentTime = 0
        void el.play().catch(() => undefined)
    } catch {
        // ignore playback errors
    }
}